// Initial route can't be a webpackChunkName, else the redirect breaks
// Why you ask? Let me know when you find out
import PortalDashboard from '../views/PortalDashboard.vue';

export const routeMain = [
  {
    path: 'home',
    name: 'Home',
    redirect: { name: 'Dashboard' }
  },
  {
    path: '',
    name: 'Dashboard',
    component: PortalDashboard,
    meta: {
      title: 'Home'
    }
  }
];
